import { create } from 'zustand';

// One-slot registry letting a page veto imperative in-app navigation started elsewhere in the
// tree. `beforeunload` and `popstate` (see useNavigationGuard) cannot see a forward
// `navigate(path)` call — no unload, no history pop — so the sidebar has no browser-level event
// to hook. It asks here instead.
//
// `blocker` is null when navigation is free. When set, callers invoke it with the intended
// destination and SKIP their own navigate() if it returns true; the guard owning the blocker is
// then responsible for completing or abandoning the navigation once the user answers.
// Single-slot on purpose: only one guarded page can be mounted at a time.
export const useNavigationBlockStore = create((set) => ({
  blocker: null,
  setBlocker: (blocker) => set({ blocker: blocker ?? null }),
}));

/**
 * Ask the active guard (if any) for permission to navigate.
 *
 * @param {{ path: string }} intent where the caller wants to go
 * @returns {boolean} true when a guard took over — the caller must not navigate itself
 */
export function requestNavigation(intent) {
  const { blocker } = useNavigationBlockStore.getState();
  return blocker ? blocker(intent) === true : false;
}
